import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { Section, Eyebrow, Heading } from '../Section';
import { CTAButton } from '../CTAButton';
import { forYouItems } from '../../data/content';
export function ForYou() {
  return <Section dark data-id="element-163" data-mp="2oc7ob7q16hl4">
      <Eyebrow data-id="element-164" data-mp="2o8jv69ohzx6x">Is Weld Decision System™ for you?</Eyebrow>
      <Heading data-id="element-165" data-mp="2tasr9ewo3fd9">This system was created for you if…</Heading>

      <ul className="mt-8 space-y-2.5" data-id="element-166" data-mp="3gzbx7ns8vg26">
        {forYouItems.map(item => <li key={item} className="flex items-start gap-3 rounded-xl border border-ink-500 bg-ink-700 px-4 py-3.5" data-id="element-167" data-mp="3gx7jke4jn2op">
            <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-flame-400" aria-hidden="true" data-id="element-168" data-mp="371xl20dctdfo" />
            <span className="text-[15px] leading-snug text-zinc-200" data-id="element-169" data-mp="3bz6380yi5hgx">{item}</span>
          </li>)}
      </ul>

      <p className="mt-8 text-center text-sm font-medium text-zinc-400" data-id="element-170" data-mp="1vke8hhdvvy4g">
        If you recognized yourself in any of these…
      </p>
      <p className="mt-2 text-center font-display text-2xl font-extrabold uppercase leading-tight text-white sm:text-3xl" data-id="element-171" data-mp="20ipknyrnikpu">
        This was built for welders who are <span className="text-flame-500" data-id="element-172" data-mp="3l9a24xyuwhsr">tired of guessing.</span>
      </p>

      <div className="mt-8" data-id="element-173" data-mp="32m05gz3sarb">
        <CTAButton data-id="element-174" data-mp="33x2dccwhagb" />
      </div>
    </Section>;
}